"use strict";

var _assertThisInitialized = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var stream_1 = require("stream");

var constants_1 = require("./constants");

var ClientUnaryCallImpl =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(ClientUnaryCallImpl, _events_1$EventEmitte);

  function ClientUnaryCallImpl(call) {
    var _this;

    _classCallCheck(this, ClientUnaryCallImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClientUnaryCallImpl).call(this));
    _this.call = call;
    call.on('metadata', function (metadata) {
      _this.emit('metadata', metadata);
    });
    call.on('status', function (status) {
      _this.emit('status', status);
    });
    return _this;
  }

  _createClass(ClientUnaryCallImpl, [{
    key: "cancel",
    value: function cancel() {
      this.call.cancelWithStatus(constants_1.Status.CANCELLED, 'Cancelled on client');
    }
  }, {
    key: "getPeer",
    value: function getPeer() {
      return this.call.getPeer();
    }
  }]);

  return ClientUnaryCallImpl;
}(events_1.EventEmitter);

exports.ClientUnaryCallImpl = ClientUnaryCallImpl;

function setUpReadableStream(stream, call, deserialize) {
  var statusEmitted = false;
  call.on('data', function (data) {
    var deserialized;

    try {
      deserialized = deserialize(data);
    } catch (e) {
      call.cancelWithStatus(constants_1.Status.INTERNAL, 'Failed to parse server response');
      return;
    }

    if (!stream.push(deserialized)) {
      call.pause();
    }
  });
  call.on('end', function () {
    if (statusEmitted) {
      stream.push(null);
    } else {
      call.once('status', function () {
        stream.push(null);
      });
    }
  });
  call.on('status', function (status) {
    if (status.code !== constants_1.Status.OK) {
      var error = Object.assign(new Error(status.details), status);
      stream.emit('error', error);
    }

    stream.emit('status', status);
    statusEmitted = true;
  });
  call.pause();
}

var ClientReadableStreamImpl =
/*#__PURE__*/
function (_stream_1$Readable) {
  _inherits(ClientReadableStreamImpl, _stream_1$Readable);

  function ClientReadableStreamImpl(call, deserialize) {
    var _this2;

    _classCallCheck(this, ClientReadableStreamImpl);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ClientReadableStreamImpl).call(this, {
      objectMode: true
    }));
    _this2.call = call;
    _this2.deserialize = deserialize;
    call.on('metadata', function (metadata) {
      _this2.emit('metadata', metadata);
    });
    setUpReadableStream(_assertThisInitialized(_assertThisInitialized(_this2)), call, deserialize);
    return _this2;
  }

  _createClass(ClientReadableStreamImpl, [{
    key: "cancel",
    value: function cancel() {
      this.call.cancelWithStatus(constants_1.Status.CANCELLED, 'Cancelled on client');
    }
  }, {
    key: "getPeer",
    value: function getPeer() {
      return this.call.getPeer();
    }
  }, {
    key: "_read",
    value: function _read(_size) {
      this.call.resume();
    }
  }]);

  return ClientReadableStreamImpl;
}(stream_1.Readable);

exports.ClientReadableStreamImpl = ClientReadableStreamImpl;

function tryWrite(call, serialize, chunk, encoding, cb) {
  var message;
  var flags = Number(encoding);

  try {
    message = serialize(chunk);
  } catch (e) {
    call.cancelWithStatus(constants_1.Status.INTERNAL, 'Serialization failure');
    cb(e);
    return;
  }

  var writeObj = {
    message: message
  };

  if (!Number.isNaN(flags)) {
    writeObj.flags = flags;
  }

  call.write(writeObj, cb);
}

var ClientWritableStreamImpl =
/*#__PURE__*/
function (_stream_1$Writable) {
  _inherits(ClientWritableStreamImpl, _stream_1$Writable);

  function ClientWritableStreamImpl(call, serialize) {
    var _this3;

    _classCallCheck(this, ClientWritableStreamImpl);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ClientWritableStreamImpl).call(this, {
      objectMode: true
    }));
    _this3.call = call;
    _this3.serialize = serialize;
    call.on('metadata', function (metadata) {
      _this3.emit('metadata', metadata);
    });
    call.on('status', function (status) {
      _this3.emit('status', status);
    });
    return _this3;
  }

  _createClass(ClientWritableStreamImpl, [{
    key: "cancel",
    value: function cancel() {
      this.call.cancelWithStatus(constants_1.Status.CANCELLED, 'Cancelled on client');
    }
  }, {
    key: "getPeer",
    value: function getPeer() {
      return this.call.getPeer();
    }
  }, {
    key: "_write",
    value: function _write(chunk, encoding, cb) {
      tryWrite(this.call, this.serialize, chunk, encoding, cb);
    }
  }, {
    key: "_final",
    value: function _final(cb) {
      this.call.end();
      cb();
    }
  }]);

  return ClientWritableStreamImpl;
}(stream_1.Writable);

exports.ClientWritableStreamImpl = ClientWritableStreamImpl;

var ClientDuplexStreamImpl =
/*#__PURE__*/
function (_stream_1$Duplex) {
  _inherits(ClientDuplexStreamImpl, _stream_1$Duplex);

  function ClientDuplexStreamImpl(call, serialize, deserialize) {
    var _this4;

    _classCallCheck(this, ClientDuplexStreamImpl);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ClientDuplexStreamImpl).call(this, {
      objectMode: true
    }));
    _this4.call = call;
    _this4.serialize = serialize;
    _this4.deserialize = deserialize;
    call.on('metadata', function (metadata) {
      _this4.emit('metadata', metadata);
    });
    setUpReadableStream(_assertThisInitialized(_assertThisInitialized(_this4)), call, deserialize);
    return _this4;
  }

  _createClass(ClientDuplexStreamImpl, [{
    key: "cancel",
    value: function cancel() {
      this.call.cancelWithStatus(constants_1.Status.CANCELLED, 'Cancelled on client');
    }
  }, {
    key: "getPeer",
    value: function getPeer() {
      return this.call.getPeer();
    }
  }, {
    key: "_read",
    value: function _read(_size) {
      this.call.resume();
    }
  }, {
    key: "_write",
    value: function _write(chunk, encoding, cb) {
      tryWrite(this.call, this.serialize, chunk, encoding, cb);
    }
  }, {
    key: "_final",
    value: function _final(cb) {
      this.call.end();
      cb();
    }
  }]);

  return ClientDuplexStreamImpl;
}(stream_1.Duplex);

exports.ClientDuplexStreamImpl = ClientDuplexStreamImpl;